import React from "react";

export const WelcomeCard = ({ styles = {}, text = {}, language = "en", userName = "", title }) => {
  const getStoredFirstName = () => {
    const stored = language === "ar" ? localStorage.getItem("employeeArabicName") : localStorage.getItem("employeeName");
    return (stored && stored.split(" ")[0]) || userName || "";
  };

  const computeTitle = () => {
    if (title) {
      if (typeof title === "object") return title[language] || title.en || Object.values(title)[0];
      // Ensure title is not empty even if displayName is empty
      const titleStr = String(title || "").trim();
      return titleStr || "Welcome";
    }

    if (text && text[language] && text[language].title) return text[language].title;

    const name = getStoredFirstName();
    const welcomeText = text && text[language] && text[language].welcome ? text[language].welcome : null;
    return welcomeText ? `${welcomeText}, ${name}` : (name || "Welcome");
  };

  const displayTitle = computeTitle();

  const defaultCard = {
    background: "transparent",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px solid rgba(0,0,0,0.06)",
    display: "block",
  };

  const mergedStyles = {
    welcomeCard: { ...(styles.welcomeCard || styles.statCard || defaultCard) },
    welcomeSection: { ...(styles.welcomeSection || { display: "flex", alignItems: "center", justifyContent: "space-between" }) },
    welcomeTitle: { ...(styles.welcomeTitle || { margin: 0, fontSize: "1.25rem", fontWeight: 700 }) },
  };

  return (
    <div style={mergedStyles.welcomeCard}>
      <div style={mergedStyles.welcomeSection}>
        <h1 style={mergedStyles.welcomeTitle}>{displayTitle}</h1>
      </div>
    </div>
  );
};

export default WelcomeCard;